import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { PRIVACY_POLICY } from "../../../../services/ApiCalls";

const PrivacyPolicy = () => {
  const [pageContent, setPageContent] = useState("");

  const getData = async (url) => {
    try {
      const response = await PRIVACY_POLICY();

      const parser = new DOMParser();
      const doc = parser.parseFromString(response.data, "text/html");
      const bodyContent = doc.body.innerHTML;
      setPageContent(bodyContent);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <section className="termsCondition py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="py-5 bg-white px-4">
                <div dangerouslySetInnerHTML={{ __html: pageContent }} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PrivacyPolicy;
